import React, { useEffect } from 'react';
import { ArrowLeft, CheckCircle, MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { aboutHighlights, contactInfo, personalInfo, workProcess } from '../data/mock';
import { applyPageMeta } from '../utils/seo';
import { trackCtaClick } from '../utils/analytics';
import Header from './Header';
import Footer from './Footer';

const SobrePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    applyPageMeta({
      title: 'Sobre | Tiago Cardoso',
      description: 'Conheça a trajetória de Tiago Cardoso, arquiteto de soluções digitais, Vivo Creator e consultor em conectividade, automação e creator tech.',
      canonical: 'https://ticardoso.com.br/sobre'
    });

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Sobre Tiago Cardoso",
      "url": "https://ticardoso.com.br/sobre",
      "mainEntity": {
        "@type": "Person",
        "name": personalInfo.name,
        "jobTitle": "Arquiteto de Soluções Digitais",
        "image": "https://ticardoso.com.br/profile.jpg",
        "url": "https://ticardoso.com.br/"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`;
    trackCtaClick({ cta: 'whatsapp', location: 'sobre', url: whatsappUrl });
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="sobre-page">
      <Header />
      <main className="sobre-content">
        <section className="section-padding">
          <div className="container-custom">
            <button onClick={() => navigate('/')} className="back-button">
              <ArrowLeft size={20} />
              Voltar para home
            </button>

            <div className="sobre-hero">
              <div className="sobre-hero-text">
                <h1 className="sobre-title">Sobre mim</h1>
                <p className="sobre-subtitle">
                  {personalInfo.headline}
                </p>
                <p className="sobre-description">
                  {personalInfo.about.split('\n\n')[0]}
                </p>
              </div>
              {personalInfo.profileImage && (
                <div className="sobre-hero-image">
                  <img
                    src={personalInfo.profileImage}
                    alt={`Foto de ${personalInfo.name}`}
                    className="sobre-avatar"
                  />
                </div>
              )}
            </div>
          </div>
        </section>

        <section className="section-padding section-bg">
          <div className="container-custom">
            <h2 className="section-title">Como eu posso ajudar</h2>
            <div className="sobre-highlights">
              {aboutHighlights.map((highlight) => (
                <div key={highlight.title} className="sobre-card">
                  <h3 className="sobre-card-title">{highlight.title}</h3>
                  <ul className="sobre-list">
                    {highlight.items.map((item) => (
                      <li key={item} className="sobre-list-item">
                        <CheckCircle size={18} />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section-padding">
          <div className="container-custom">
            <h2 className="section-title">Processo de trabalho</h2>
            <div className="process-grid">
              {workProcess.map((step) => (
                <div key={step.title} className="process-card">
                  <h3 className="process-title">{step.title}</h3>
                  <p className="process-description">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section-padding section-bg">
          <div className="container-custom">
            <div className="sobre-cta">
              <h2 className="section-title">Quer tirar seu projeto do papel?</h2>
              <p className="section-description">
                Vamos conversar sobre suas metas e criar um plano de ação com tecnologia que funciona.
              </p>
              <button onClick={handleWhatsAppClick} className="btn-primary btn-large">
                <MessageCircle size={24} />
                Falar no WhatsApp
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SobrePage;
